import React, { useEffect } from 'react';
import { components as selectComponents } from 'react-select';
import { arrayOf, func, number, object, oneOfType, shape, string } from 'prop-types';
import getIndexOfSubstring from '../getIndexOfSubstring';
import { selectPropsPropTypes } from '../shapes';
export var SelectContainer = function SelectContainer(props) {
  var options = props.options,
      selectOption = props.selectOption,
      _props$selectProps = props.selectProps,
      autoSelectAloneValue = _props$selectProps.autoSelectAloneValue,
      inputValue = _props$selectProps.inputValue;
  useEffect(function () {
    if (autoSelectAloneValue) {
      var filteredOptions = options.filter(function (_ref) {
        var label = _ref.label;
        return getIndexOfSubstring(label, inputValue) === 0;
      });

      if (filteredOptions.length === 1) {
        selectOption(filteredOptions[0]);
      }
    }
  }, [autoSelectAloneValue, inputValue, options, selectOption]);
  return /*#__PURE__*/React.createElement(selectComponents.SelectContainer, props);
};
SelectContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  selectProps: selectPropsPropTypes,
  selectOption: func,
  options: arrayOf(shape({
    label: oneOfType([string, number, object]),
    value: oneOfType([string, number])
  })).isRequired
} : {};
export default SelectContainer;